export default "__VITE_ASSET__7b59ffb5__"